/**
 * JSON-LD Schema components — rendered as inline <script type="application/ld+json">
 * with dangerouslySetInnerHTML. Valid per Google's structured data spec (scripts
 * can appear anywhere in the document, not just <head>).
 *
 * Migrated off react-helmet-async (incompatible with React 19).
 */

const JsonLd = ({ schema, id }) => (
  <script
    type="application/ld+json"
    id={id}
    dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
  />
);

export const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "TravelAgency",
    "name": "Velmora Holidays",
    "image": "https://velmoraholidays.com/logo.png",
    "description":
      "Best travel agency in Kashmir offering customized Kashmir tour packages. Expert tour guides, competitive prices, and authentic Kashmir experiences.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Khayam Chowk, Near Hotel Royal Batoo",
      "addressLocality": "Srinagar",
      "addressRegion": "Jammu and Kashmir",
      "postalCode": "190001",
      "addressCountry": "IN",
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "34.083656",
      "longitude": "74.797371",
    },
    "telephone": "+91-9419016969",
    "email": "info@velmoraholidays.com",
    "url": "https://velmoraholidays.com",
    "priceRange": "₹₹",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
        "opens": "09:00",
        "closes": "20:00",
      },
    ],
    "sameAs": [
      "https://www.facebook.com/velmoraholidays",
      "https://www.instagram.com/velmoraholidays",
      "https://twitter.com/velmoraholidays",
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "6",
      "bestRating": "5",
      "worstRating": "1",
    },
  };
  return <JsonLd schema={schema} id="ld-local-business" />;
};

export const FAQSchema = ({ faqs }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.a,
      },
    })),
  };
  return <JsonLd schema={schema} id="ld-faq" />;
};

export const TourPackageSchema = ({ pkg }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    "name": pkg.name,
    "description": pkg.description,
    "image": pkg.image,
    "provider": {
      "@type": "TravelAgency",
      "name": "Velmora Holidays",
      "url": "https://velmoraholidays.com",
    },
    "offers": {
      "@type": "Offer",
      "price": pkg.price.replace('₹', '').replace(',', ''),
      "priceCurrency": "INR",
      "availability": "https://schema.org/InStock",
      "validFrom": "2025-01-01",
    },
    "itinerary": {
      "@type": "ItemList",
      "itemListElement": pkg.destinations.map((dest, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Place",
          "name": dest,
        },
      })),
    },
    "duration": pkg.duration,
  };
  return <JsonLd schema={schema} id="ld-tour-package" />;
};

export const ReviewSchema = ({ reviews }) => {
  const schema = reviews.map((review) => ({
    "@context": "https://schema.org",
    "@type": "Review",
    "author": {
      "@type": "Person",
      "name": review.name,
    },
    "datePublished": review.date,
    "reviewBody": review.text,
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": review.rating.toString(),
      "bestRating": "5",
      "worstRating": "1",
    },
    "itemReviewed": {
      "@type": "TravelAgency",
      "name": "Velmora Holidays",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Srinagar",
        "addressCountry": "IN",
      },
    },
  }));
  return <JsonLd schema={schema} id="ld-reviews" />;
};

export const BreadcrumbSchema = ({ items }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
        ? `https://velmoraholidays.com${item.url}`
        : undefined,
    })),
  };
  return <JsonLd schema={schema} id="ld-breadcrumb" />;
};
